import { useEffect, useState } from "react";
import Notification from "../../../../components/toast";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { schema, schemaDefaultValues } from "./schema";

export const IndexHook = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	fetchID,
	reloadData,
	insert,
}) => {
	const {
		register,
		handleSubmit,
		setValue,
		setFocus,
		setError,
		trigger,
		watch,
		reset,
		control,
		formState: { errors, isSubmitting },
	} = useForm({
		mode: "onSubmit",
		//quando revalidar os campos
		resolver: zodResolver(schema),
		defaultValues: schemaDefaultValues,
	});

	// const [id_forma, setid_forma] = useState(0);
	const url_banner = watch("url_banner");
	const id_banner = watch("id_banner");
	const [loading, setLoading] = useState(false);

	const handleCloseModalRegister = () => {
		const event = new CustomEvent(`${ident}`);
		window.dispatchEvent(event);
	};

	//#region Fetch
	useEffect(() => {
		if (isOpenModalRegister) {
			const id =
				typeof selectedData[idTable] === "number" && !isNaN(selectedData[idTable]) ? selectedData[idTable] : 0;

			if (id > 0) {
				fetch(id);
			}
		} else {
			if (setSelectData) setSelectData({});

			reset();
		}
	}, [isOpenModalRegister, selectedData]);

	const fetch = async (id) => {
		try {
			setLoading(true);

			const response = await fetchID(id);

			if (response.data && typeof response.data === "object") {
				const data = response.data;

				// const newData = await processNewData(data);

				Object.keys(data).forEach((field) => {
					setValue(field, data[field]);
				});
			}
		} catch (error) {
			Notification.showToast({
				message: error.message,
				type: "warning",
			});
		} finally {
			setLoading(false);
		}
	};

	//#region onSubmit
	const handleOnSubmit = async (data) => {
		try {
			let response;

			// const newDate = ValidateSubmit(data);

			response = await insert(data);

			// const currentId = response.data[idTable];
			const currentId = response.data.id_banner;

			await reloadData(data[idTable], currentId);

			Notification.showToast({
				message: "Registro salvo com sucesso.",
				type: "success",
			});
			reset();
			handleCloseModalRegister();
		} catch (error) {
			if (error.field && error.field !== "ID_FORMA") {
				// errosAfterPost(error.field, error.message);
			} else
				Notification.showToast({
					message: error.message,
					type: "error",
				});
		}
	};

	//#endregion
	const onChangeUploadBanner = (data) => {
		setValue("url_banner", data.url);
	};

	//#region
	const [valueTab, setValueTab] = useState("0");
	useEffect(() => {
		const focusField = {
			0: "nome",
			1: "qtatual",
		};

		if (focusField[valueTab]) {
			setFocus(focusField[valueTab]);
		}
	}, [valueTab, setFocus]);

	const fieldsByTab = {
		//fields de cada tab para fazer validações
		0: ["descricao", "ordem"],
		1: [],
	};

	const handleChangeTab = async (event, newValue) => {
		event.preventDefault();
		const currentTabFields = fieldsByTab[valueTab];

		const validFields = await trigger(currentTabFields); // Valida apenas os campos da aba atual

		if (validFields) {
			await validNewTab(newValue);
		} else {
			Notification.showToast({
				message: "Preencha os campos obrigatórios antes de mudar de aba",
				type: "warning",
			});
		}
	};

	const validNewTab = async (newValue) => {
		if (newValue === "1") {
			//se for a tabela de fotos
			if (id_banner === 0) {
				// 	//salva o produto para pegar o id_produto
				await handleSubmit(async (data) => {
					await submitNextPage(data, newValue);
				})();
				return;
			}
		}
		setValueTab(newValue);
	};
	const submitNextPage = async (data, newPage) => {
		try {
			let response;

			// const newDate = ValidateSubmit(data);

			response = await insert(data);

			// const currentId = response.data[idTable];
			const currentId = response.data.id_banner;

			setValue("id_banner", currentId);
			setValueTab(newPage);
			await reloadData(data[idTable], currentId);

			Notification.showToast({
				message: "Registro salvo com sucesso.",
				type: "success",
			});
		} catch (error) {
			if (error.field && error.field !== "ID_FORMA") {
				// errosAfterPost(error.field, error.message);
			} else
				Notification.showToast({
					message: error.message,
					type: "error",
				});
		}
	};
	//#endregion

	return {
		//hooks
		handleOnSubmit,
		handleCloseModalRegister,

		onChangeUploadBanner,

		//useForm
		register,
		handleSubmit,
		setValue,
		control,
		setFocus,

		id_banner,

		valueTab,
		handleChangeTab,
		loading,
		url_banner,
		//formState
		errors,
		isSubmitting,
	};
};

// 	// Dispara a validação do formulário antes de enviar
// 	const result = await trigger();
// 	if (result) {
// 		// Chama `handleSubmit` e captura o resultado de `handleOnSubmit`
// 		const success = await new Promise((resolve) => {
// 			handleSubmit(
// 				async (data) => {
// 					const result = await handleOnSubmit(data);
// 					resolve(result); // Resolve com o resultado de `handleOnSubmit`
// 				},
// 				(errors) => {
// 					resolve(false); // Resolve com `false` se houver erros
// 				}
// 			)();
// 		});

// 		return success; // Retorna o valor de sucesso/falha
// 	}
// 	return false; // Retorna `false` se a validação falhar
// };
